import { ErrorOutlineOutlined } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const AiScreeningLimitAlert: React.FC = () => {
  const { formatMessage } = useIntl()

  return (
    <Stack bgcolor="error.light" p={2} direction="row" spacing={1.5} borderRadius={2}>
      <ErrorOutlineOutlined />
      <Stack>
        <Typography variant="subtitle1">
          {formatMessage({ id: 'aiScreening.infoPage.noRemainingScreeningsTitle' })}
        </Typography>
        <Typography variant="body2">
          {formatMessage({ id: 'aiScreening.infoPage.noRemainingScreeningsDescription' })}
        </Typography>
      </Stack>
    </Stack>
  )
}

export default AiScreeningLimitAlert
